import { PreviousJob } from '../models/previousJob.model';
export class AddPreviousJob {
    static readonly type = '[Previous Job] Add';
    constructor(public payload: PreviousJob) {}
}

export class RemovePreviousJob {
    static readonly type = '[Previous Job] Remove';
    constructor(public payload: PreviousJob) {}
}

export class ClearPreviousJob {
    static readonly type = '[Previous Job] Clear';
    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/previousJob.action.ts